// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description A service on a case
*/
export class CaseServiceModel {
    'serviceTypeCode'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CaseServiceModel>> = [
        {
            "name":     "serviceTypeCode",
            "baseName": "serviceTypeCode",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return CaseServiceModel.attributeTypeMap;
    }
}
